const BILLING_TYPE = {
  STRIPE: 1,
  PADDLE: 2,
};

export default BILLING_TYPE;
